// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vCpz","footer":"styles_footer__1sQ5i"};